<template>
  <form @submit.prevent="onSearch">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <SelectVue
            v-model="filters.userId"
            :options="userDropdown"
            :is-clear="true"
            :placeholder="$t('Mitarbeiter')"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <div v-if="yearsDropdown && yearsDropdown.length">
          <SelectVue
              v-model="filters.year"
              :options="yearsDropdown"
              :placeholder="$t('Year')"/>
        </div>
      </div>
      <div class="col-lg-2 col-sm-12 col-12">
        <SearchButton
            type="submit"
            :label="$t('general.button.search')"
            :loading="loading"/>
      </div>
    </div>
  </form>
</template>

<script setup>

import SelectVue from '@/components/SelectVue.vue';
import SearchButton from '@/components/button/SearchButton.vue';
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  userDropdown: {
    type: Array,
    require: true,
  },
  yearsDropdown: {
    type: Array,
    require: true,
  },

  filters: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },

});

const emit        = defineEmits([ 'search' ]);
const { filters } = toRefs(props);

function onSearch() {
  emit('search', 1, undefined, filters.value);
}
</script>

<style scoped></style>
